import { Page } from "../../../Components/Page";
import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "@mantine/form";
import { playerCorrectPersonalData } from "../../../openapi/api-client";
import { Button, Group, Loader, Stack, TextInput } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { useRequiredParams } from "../../../hooks/useRequiredParams";
import { usePlayer } from "../../../hooks/usePlayer.ts";
import { DatePickerInput } from "@mantine/dates";
import { DateTime } from "luxon";

export const PlayerEdit: FC = () => {
  const navigate = useNavigate();
  const { playerId } = useRequiredParams(["playerId"]);

  const playerData = usePlayer(playerId);

  const form = useForm<{
    firstName: string;
    lastName: string;
    birthday: Date | null;
  }>({
    initialValues: {
      firstName: "",
      lastName: "",
      birthday: null,
    },
  });

  useEffect(() => {
    if (!playerData.isSuccess) {
      return;
    }

    form.setFieldValue("firstName", playerData.data.firstName);
    form.setFieldValue("lastName", playerData.data.lastName);
    form.setFieldValue(
      "birthday",
      DateTime.fromISO(playerData.data.birthday).toJSDate(),
    );
  }, [playerData.data, playerData.isSuccess]);

  const correctPersonalDataMutation = useMutation({
    mutationFn: playerCorrectPersonalData,
  });

  const onSubmit = form.onSubmit(async (values) => {
    if (!playerData.isSuccess || !values.birthday) {
      return;
    }

    await correctPersonalDataMutation.mutateAsync({
      id: playerData.data.id,
      firstName: values.firstName,
      lastName: values.lastName,
      birthday: new Date(values.birthday).toISOString(),
    });

    void navigate(`../..`, { relative: "path" });
  });

  if (!playerData.isSuccess) {
    return <Loader />;
  }

  return (
    <Page
      title={`${playerData.data.firstName} ${playerData.data.lastName} bearbeiten`}
    >
      <form onSubmit={onSubmit}>
        <Stack align="flex-start" justify="flex-start">
          <Group>
            <TextInput
              placeholder="Max"
              label="Vorname"
              required
              {...form.getInputProps("firstName")}
            />

            <TextInput
              placeholder="Mustermann"
              label="Nachname"
              required
              {...form.getInputProps("lastName")}
            />
          </Group>

          <DatePickerInput
            label="Geburtstag"
            required
            clearable={false}
            {...form.getInputProps("birthday")}
          />

          <Group mt="md">
            <Button type="submit">Speichern</Button>
          </Group>
        </Stack>
      </form>
    </Page>
  );
};
